import FormatBoldIcon from "@mui/icons-material/FormatBold";
import { Text, ToggleButton } from "designSystem/index";
import React, { useState } from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => {
	const [value, setValue] = useState(false);

	return (
		<CssColumnGrid columns={3}>
			<Text semiBold text="enabled" />
			<Text semiBold text="disabled" />
			<Text semiBold text="disabled and selected" />
			<ToggleButton
				onClick={() => setValue(!value)}
				selected={value}
				tooltipProps={{ res: "FormatBold" }}
				value="bold1"
			>
				<FormatBoldIcon />
			</ToggleButton>
			<ToggleButton
				disabled
				selected={false}
				tooltipProps={{ res: "FormatBold" }}
				value="bold2"
			>
				<FormatBoldIcon />
			</ToggleButton>
			<ToggleButton
				disabled
				selected
				tooltipProps={{ res: "FormatBold" }}
				value="bold3"
			>
				<FormatBoldIcon />
			</ToggleButton>
		</CssColumnGrid>
	);
};